import { render, staticRenderFns } from "./LogUltimasCargas.vue?vue&type=template&id=c311db42&scoped=true"
import script from "./LogUltimasCargas.vue?vue&type=script&lang=js"
export * from "./LogUltimasCargas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c311db42",
  null
  
)

export default component.exports